import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { User } from 'oidc-client';
import { Observable } from 'rxjs';
import { GridColumnsConfiguration, GridColumnsConfigurationByUserResponse, GridColumnsConfigurationResponse } from '../../models/contact-modal/gridColumnsConfiguration.model';
import { delayedRetryHttp } from '../contact-services/shared/delayedRetry';
import { UtilityService } from '../contact-services/shared/utility.service';
import { catchError } from 'rxjs/operators';
import { SimpleResponse } from '../../models/contact-modal/genericResponse.model';

@Injectable({
  providedIn: 'root'
})
export class GridColumnsConfigurationService {

  private baseUrl: string;
  private _baseUrl: string;
    private api: string = "api/Engage/GridColumnsConfiguration";
    private apiContact: string = "api/Engage/Contact";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
    this._baseUrl = _baseUrl + this.apiContact;
  }

  async createGridColumnsConfiguration(encryptedUser: string, gridColumnsConfiguration: GridColumnsConfiguration): Promise<GridColumnsConfigurationResponse | void> {
    const a = await this.httpClient.post<GridColumnsConfigurationResponse>(`${this.baseUrl}/GridColumnsConfiguration_Create/`, gridColumnsConfiguration, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, gridColumnsConfiguration, "r - " + encryptedUser , encryptedUser, "GridColumnsConfigurationService", "createGridColumnsConfiguration"); });
    return a;
  }

  async getGridColumnsConfiguration(encryptedUser: string, clpUserId: number, tableName: string): Promise<GridColumnsConfigurationResponse | void> {
    const a = await this.httpClient
      .get<GridColumnsConfigurationResponse>(`${this.baseUrl}/GetGridColumnsConfiguration/${clpUserId}/${tableName}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserId - " + clpUserId + " , " + "tableName - " + tableName, encryptedUser, "GridColumnsConfigurationService", "getGridColumnsConfiguration"); }); 
    return a;
  }

  async getGridColumnsConfigurationUser(encryptedUser: string, clpUserId: number): Promise<GridColumnsConfigurationByUserResponse | void> {
    const a = await this.httpClient
      .get<GridColumnsConfigurationResponse>(`${this.baseUrl}/GetGridColumnsConfigurationByUser/${clpUserId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "clpUserId - " + clpUserId, encryptedUser, "GridColumnsConfigurationService",  "getGridColumnsConfigurationUser"); });
    return a;
  }

  async deleteGridColumnsConfiguration(encryptedUser: string, cLPUserID: number, tableName: string): Promise<SimpleResponse | void> {
    const a = await this.httpClient
      .get<SimpleResponse>(`${this._baseUrl}/GridColumnsConfiguration_Delete/${cLPUserID}/${tableName}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "r - " + encryptedUser + " , " + "cLPUserID - " + cLPUserID + " , " + "tableName - " + tableName , encryptedUser, "GridColumnsConfigurationService", "deleteGridColumnsConfiguration"); }); 
    return a;
  }
}
